import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetSelfOnboardingDataInput,
  GetSelfOnboardingDataGraphQLRequest,
  GetSelfOnboardingDataResponse,
} from '../types';

const getSelfOnboardingDataQuery = gql`
  query GetSelfOnboardingData($input: GetSelfOnboardingDataInput!) {
    getSelfOnboardingData(input: $input) {
      code
      success
      message
      data {
        basicDetails {
          name
          email
          hireDate
          designation
          department
          managerPeopleId
          managerName
          location
          officeLocationId
        }
        personalDetails
        compensationDetails {
          salaryStructureType
          ctc
          variablePay
          earnings {
            basic
            hra
            lta
            sa
            da
            pf
            esi
            nps
            customAllowances {
              name
              amount
              taxable
            }
          }
        }
        complianceDetails {
          isTds
          isPf
          isEsi
          isPt
          isLwf
        }
        userStatutoryDetails {
          panNumber
          locationPt
          locationLwf
          pfStatus
          esicStatus
          pfUan
          esicIp
        }
      }
    }
  }
`;

export const getSelfOnboardingData = (input: GetSelfOnboardingDataInput) => {
  return graphQLApi<GetSelfOnboardingDataResponse, GetSelfOnboardingDataGraphQLRequest>({
    query: getSelfOnboardingDataQuery,
    queryVariables: { input },
  });
};
